import { GridColumn } from "@progress/kendo-react-grid";
import { FilterDescriptor, SortDescriptor } from "@progress/kendo-data-query";
import { useNavigate } from "react-router-dom";
import { protectedResources } from '../../authConfig';
import { BaseGrid, ButtonHelper } from '../../components/KendoGrid/BaseGrid';
import { ActiveCell, FacilityNameCell } from '../../components/KendoGrid/SharedCells';
import { ActiveFilter } from '../../components/KendoGrid/ActiveFilter';

interface PipetListProps {
    labId?: number,
    children?: React.ReactNode
}

const PipetList = (props: PipetListProps) => {
    const navigate = useNavigate();

    const alphabeticalSort = [{
        field: "OperatorName",
        dir: "asc"
    } as SortDescriptor];

    const gridFilter = props.labId ? [{
        field: "LabId",
        operator: "eq",
        value: props.labId,
    }] as FilterDescriptor[] : undefined;

    return (
        <BaseGrid filter={gridFilter} intialSort={alphabeticalSort} verb={'POST'} pageTitle='Pipet List' endpoint={protectedResources.apiPipet.endpoint + "KendoGridRead"} redirectUrl="/pipet-manage/"
            button={[{ onClick: () => { { navigate("/pipet-manage"); } }, buttonText: 'Create New Pipet' } as ButtonHelper]}
            excelFunction={(pipet: any) => {
                const p = { ...pipet };
                const inactive = pipet.inactiveDate
                if (p.inactiveDate !== undefined) {
                    p.inactiveDate = (inactive ? "Inactive" : "Active")
                }

                return p
            }}>
            <GridColumn field="serialNumber" title="Name / Serial Number" />
            {!props.labId &&
                <GridColumn field="lab.facilityName" cell={FacilityNameCell} title="Facility Name" />}
            <GridColumn field="manufacturer" title="Manufacturer" />
            <GridColumn field="volume" filter="numeric" title="Volume" />
            <GridColumn field="inactiveDate" title="Active" cell={ActiveCell} filterCell={ActiveFilter} />
        </BaseGrid>
    );
}


export default PipetList;